import { userInstance } from './base'

export const BASE_URL = 'tariff'

export type PlanItem = {
  id: number
  name: string
  name_en: string
  daysGranted: number
  price: number
  price_usd: number
}

export type PlanResponse = Array<PlanItem>

export type PlanItemsType = PlanResponse

export const getUserPlans = async (): Promise<PlanItemsType> => {
  try {
    const response = await userInstance.get(`${BASE_URL}/all`)
    return response.data
  } catch (error: unknown) {
    return await Promise.reject(error)
  }
}
